<template>
  <Modal
    :title="$t('customer.branches.modals.confirmDelete.title')"
    name="CONFIRM_DELETE_BRANCH"
    actions
  >
    <template v-slot:body>
      <v-card class="pa-5" color="orange lighten-5" elevation="0">
        <span class="orange--text">
          {{ $t('customer.branches.modals.confirmDelete.text') }}
        </span>
      </v-card>
      <!-- Opt-in because this modal is shared with the admin branch list: only /web/branch/delete moves
           the users to the headquarter, the admin endpoint leaves them where they are. -->
      <v-card
        v-if="migratesUsersToHeadquarter"
        class="pa-5 mt-3"
        color="blue lighten-5"
        elevation="0"
      >
        <div class="d-flex align-start">
          <v-icon class="mr-2" color="blue darken-2" small>mdi-information-outline</v-icon>
          <span class="blue--text text--darken-2">
            {{ $t('customer.branches.modals.confirmDelete.usersMigrateToHeadquarter') }}
          </span>
        </div>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('CONFIRM_DELETE_BRANCH')"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('customer.branches.modals.confirmDelete.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="confirm"
        color="primary"
        elevation="0"
        class="ml-5"
        dark
      >
        {{ $t('customer.branches.modals.confirmDelete.buttons.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/components/app/Modal'
export default {
  name: 'ModalBranchConfirmDelete',
  components: {
    Modal,
  },
  props: {
    /** Shows the notice that the users of the branch are moved to the headquarter on delete. */
    migratesUsersToHeadquarter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      branch: null,
    }
  },
  methods: {
    ...mapActions(['closeModal', 'openModal']),
    openConfirmModal(branch) {
        this.branch = branch
        this.openModal('CONFIRM_DELETE_BRANCH')
    },
    confirm() {
        this.$emit("confirm", this.branch)
        this.closeModal('CONFIRM_DELETE_BRANCH')
    },
  },
}
</script>
